module.exports = __webpack_public_path__ + "static/media/rotulo-lager.00d02e7d.png";